import FirmwareStatus from './FirmwareStatus';

export default FirmwareStatus;
